module.exports = __webpack_public_path__ + "static/media/game-controller.ea8eea4c.svg";